import { from, firstValueFrom } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import store from '@Store';
import { CONDITIONS_DRAW_PAGE_TITLE, CONDITIONS_PAGE_TITLE } from '@Pages/Conditions/constants';
import { getConditionsDetailHasSettled, getConditionsDetailRun } from '@Pages/Conditions/selectors';

function getProjectTitle(run = {}) {
  return run?.projectName || run?.name || (run?.number ? `${CONDITIONS_PAGE_TITLE} result #${run.number}` : '');
}

export function conditionsProjectsMapper() {
  return {
    pageName: CONDITIONS_PAGE_TITLE,
  };
}

export function conditionsDrawMapper() {
  return {
    pageName: CONDITIONS_PAGE_TITLE,
    title: CONDITIONS_DRAW_PAGE_TITLE,
  };
}

export async function conditionsDetailMapper({ id, projectName, name, number } = {}) {
  const routeTitle = projectName || name || (number ? `${CONDITIONS_PAGE_TITLE} result #${number}` : '');
  if (routeTitle) {
    return {
      pageName: CONDITIONS_PAGE_TITLE,
      title: routeTitle,
    };
  }

  const state = store.getState();
  const currentRun = getConditionsDetailRun(state, id);
  const currentTitle = getProjectTitle(currentRun);
  if (currentTitle) {
    return {
      pageName: CONDITIONS_PAGE_TITLE,
      title: currentTitle,
    };
  }

  const run = await firstValueFrom(
    from(store).pipe(
      filter((nextState) => getConditionsDetailRun(nextState, id) || getConditionsDetailHasSettled(nextState, id)),
      map((nextState) => getConditionsDetailRun(nextState, id)),
      take(1)
    )
  );

  return {
    pageName: CONDITIONS_PAGE_TITLE,
    title: getProjectTitle(run) || `Project #${id}`,
  };
}
